
export const BROWSER_REMOVE_TICKET = 'browser-remove-ticket';
export const BROWSER_REMOVE_FOR_SSO = 'browser-remove-for-sso'
export const BROWSER_REMOVE_FOR_OFFICE_ADD_IN = 'browser-remove-for-office-add-in'
export const BROWSER_HOME_PAGE = 'browser-home-page';
export const BROWSER_CLEAN_CACHE = 'browser-clean-cache';
export const USER_SIGN_IN_SUCCESS = 'ev-user-sign-in';// 'sign-in-successfully';'sign-in-successfully';
export const USER_SIGN_IN_FAILED = 'sign-in-failed';
export const USER_UPDATE_SUBSCRIPTION = 'update-subscription';
export const GOT_USER_SUBSCRIPTION = 'has-got-user-subscription';
export const USER_IS_ADMIN = 'user-is-admin';
export const GET_IS_EDU_SUCCESS = 'get-is-edu-success'
export const IS_DONE_SURVEY_FOR_EDU_EN = 'isDonSurveyForEduEn'
export const PHANTOM_ONLINE = 'PhantomOnline'
export const PHANTOM = 'Phantom'
export const LANG_CHANGE = 'langChange'
export const USER_TEMP_TRIAL = 'user-temp-trial';
export const DRIVE_DLG_TYPE_SAVE_AS = 'save-as'
export const DRIVE_DLG_TYPE_COMBINE = 'combine'
export const DRIVE_DLG_TYPE_CONVERT = 'convert'

export const SDK_FINISH_LOAD = 'sdk-finish-load';
export const SDK_RENDER_FIRST_PAGE = 'sdk-render-first-page';

export const FW_USER_LOGIN_IN_SUCCESS = 'fw-user-login-in-seccess';






